/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Tolerance_HelpInputs */



/**
* | output |
* | --- |
* | "Tolerance for start points in seconds" |
*
* @param {Start_Tolerance_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const start_tolerance_help = /** @type {((inputs?: Start_Tolerance_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Tolerance_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tolérance pour les points de début en secondes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Toleranz für Startpunkte in Sekunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tolleranza per i punti di partenza in secondi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Допуск для начальных точек в секундах")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tolerancia para puntos de inicio en segundos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("起始点容差（秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始点の許容範囲（秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रारंभ बिंदुओं के लिए सहनशीलता (सेकंड में)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tolerância para pontos de partida em segundos")
	return /** @type {LocalizedString} */ ("Tolerance for start points in seconds")
});